import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { OpenInNew as ExternalLinkIcon, ElectricBolt as ElectricIcon } from '@mui/icons-material';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        pt: 3,
        pb: 2,
        px: 3,
        background: 'linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 0.4) 100%)',
        borderTop: '1px solid rgba(0, 212, 255, 0.1)',
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: '10%',
          right: '10%',
          height: '1px',
          background: 'linear-gradient(90deg, transparent, rgba(0, 212, 255, 0.3), transparent)',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'space-between',
          alignItems: { xs: 'center', md: 'flex-start' },
          gap: 3,
        }}
      >
        {/* Left side - Logo & Branding */}
        <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1, justifyContent: { xs: 'center', md: 'flex-start' } }}>
            <ElectricIcon sx={{ color: '#00d4ff', fontSize: 20 }} />
            <Typography
              variant="body2"
              sx={{
                fontWeight: 700,
                background: 'linear-gradient(90deg, #00d4ff, #00ff88)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              EnergyCosmos
            </Typography>
          </Box>
          <Typography
            variant="caption"
            sx={{ color: 'rgba(255, 255, 255, 0.5)', display: 'block' }}
          >
            Powered by{' '}
            <Link
              href="https://coreconsultingit.com/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: '#00d4ff',
                textDecoration: 'none',
                fontWeight: 500,
                transition: 'all 0.2s ease',
                '&:hover': {
                  color: '#00ff88',
                },
              }}
            >
              Core Consulting IT
              <ExternalLinkIcon sx={{ fontSize: 12, ml: 0.5, verticalAlign: 'middle' }} />
            </Link>
          </Typography>
        </Box>

        {/* Center - Copyright */}
        <Box sx={{ textAlign: 'center' }}>
          <Typography
            variant="caption"
            sx={{ color: 'rgba(255, 255, 255, 0.4)' }}
          >
            © {currentYear} EnergyCosmos. All rights reserved.
          </Typography>
        </Box>

        {/* Right side - Data attribution */}
        <Box sx={{ textAlign: { xs: 'center', md: 'right' } }}>
          <Typography
            variant="caption"
            sx={{ color: 'rgba(255, 255, 255, 0.5)', display: 'block', mb: 0.5 }}
          >
            Data provided by{' '}
            <Link
              href="https://www.elexon.co.uk/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: 'rgba(255, 255, 255, 0.7)',
                textDecoration: 'none',
                transition: 'color 0.2s ease',
                '&:hover': { color: '#00d4ff' },
              }}
            >
              Elexon BMRS API
            </Link>
          </Typography>
          <Typography
            variant="caption"
            sx={{
              color: 'rgba(255, 255, 255, 0.3)',
              fontSize: '0.7rem',
            }}
          >
            For informational purposes only
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
